export const FETCH_KIOSK_SETTINGS = 'FETCH_KIOSK_SETTINGS';
export const FETCH_KIOSK_USER = 'FETCH_KIOSK_USER';
export const FETCH_KIOSK_JOBS = 'FETCH_KIOSK_JOBS';
export const FETCH_KIOSK_SELECTED_JOB = 'FETCH_KIOSK_SELECTED_JOB';
export const FETCH_KIOSK_MOMENTS = 'FETCH_KIOSK_MOMENTS';
export const FETCH_KIOSK_SELECTIONS = 'FETCH_KIOSK_SELECTIONS';
export const FETCH_KIOSK_EMAIL = 'FETCH_KIOSK_EMAIL';
export const FETCH_MOMENT_COUNT = 'FETCH_MOMENT_COUNT';

export const SELECT_KIOSK_MOMENTS = 'SELECT_KIOSK_MOMENTS';
export const UNSELECT_KIOSK_MOMENTS = 'UNSELECT_KIOSK_MOMENTS';

export const VIEW_CATALOG = 'VIEW_CATALOG';
export const VIEW_GALLERY = 'VIEW_GALLERY';
export const VIEW_CART = 'VIEW_CART';
export const VIEW_RECEIPT = 'VIEW_RECEIPT';
export const VIEW_PRE_PRINT = 'VIEW_PRE_PRINT';

export const SHOW_MOMENT = 'SHOW_MOMENT';

export const KIOSK_LOADED = 'KIOSK_LOADED';
export const SET_CURRENT_DATE = 'SET_CURRENT_DATE';
export const SET_DATES = 'SET_DATES';
export const SET_PURCHASE_REQUEST = 'SET_PURCHASE_REQUEST';
export const FETCH_PURCHASES = 'FETCH_PURCHASES';
export const FETCH_PRINTS = 'FETCH_PRINTS';
export const SET_PURCHASED = 'SET_PURCHASED';

export const FETCH_ROOM_MOMENTS = 'FETCH_ROOM_MOMENTS';
export const FETCH_GUESTS = 'FETCH_GUESTS';

export const FETCH_FAMILY = 'FETCH_FAMILY';
export const FETCH_VISITS = 'FETCH_VISITS';
export const FETCH_VISIT = 'FETCH_VISIT';
export const REMOVE_VISIT = 'REMOVE_VISIT';

export const FETCH_MERGED_STORIES = 'FETCH_MERGED_STORIES';
export const ADD_MERGED_STORY = 'ADD_MERGED_STORY';

export const SELECT_LOCALE = 'SELECT_LOCALE';

export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';
export const GET_KIOSK_PRINT_SIZES = 'GET_KIOSK_PRINT_SIZES';
export const FETCH_PORTAL_MOMENTS = 'FETCH_PORTAL_MOMENTS';
export const SELECT_PRE_PRINTS = 'SELECT_PRE_PRINTS';
export const UNSELECT_PRE_PRINTS = 'UNSELECT_PRE_PRINTS';
export const CLEAR_PRE_PRINTS = 'CLEAR_PRE_PRINTS';
export const GET_KNOCKOUT_ELEMENTS = 'GET_KNOCKOUT_ELEMENTS';
export const SET_DEFAULT_KIOSK_READER = 'SET_DEFAULT_KIOSK_READER';
export const GET_STRIPE_READERS = 'GET_STRIPE_READERS';
export const VIEW_VIDEO = "VIEW_VIDEO";
export const VALIDATE_KNOCKOUT_ELEMENTS = "VALIDATE_KNOCKOUT_ELEMENTS";
export const CHECK_EXISTING_EDITS = "CHECK_EXISTING_EDITS";
export const SHOW_PRINT_SIZE_EDITS = "SHOW_PRINT_SIZE_EDITS";
export const SELECT_PRINT_SIZE_FOR_CROP = "SELECT_PRINT_SIZE_FOR_CROP";
export const TIMEOUT_DIALOG_OPEN = "TIMEOUT_DIALOG_OPEN";